import React, { useState } from 'react';
import parser from 'html-react-parser'
import logo from '../../../../assets/logo.png';
import './CampaignsPreviewPhone.css';
import dislike from '../../../../assets/svg/dislike.svg'
import like from '../../../../assets/svg/like.svg'
import favorites from '../../../../assets/svg/love.svg'


const CampaignsPreviewPhone = (props) => {
    const {newCampaignData, companyData, companyLogoURL, carouselItems = []} = props;
    const [currentSlide, setCurrentSlide] = useState(0);

    const isCarouselMode = newCampaignData.campaignMode === 'carousel' && carouselItems.length > 0;

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % carouselItems.length);
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + carouselItems.length) % carouselItems.length);
    };

    return (
        <div className='preview-smart-phone-wrapper'>
            <div className='preview-smart-phone'>
                <div className='preview-smart-phone-content-wrapper'>
                    <div className='preview-smart-phone-content'>
                        <div className='phone-content-company-data-wrapper'>
                            <div className='phone-company-logo-wrapper'>
                                <img className='company-logo' src={companyLogoURL ? companyLogoURL : logo} alt="logo"/>
                            </div>
                            <div className='phone-content-company-name-address-wrapper'>
                                <p className='company-type-name'>{companyData.typeOfBusiness}, {companyData.name}</p>
                                <p className='company-address-city'>{companyData.streetName} {companyData.streetNum}, {companyData.zip} {companyData.city}</p>
                            </div>
                        </div>
                        <div className='phone-content-company-campaign-offer'>
                            {isCarouselMode ? (
                                <div className='carousel-preview'>
                                    <div className='carousel-preview-slide'>
                                        <img
                                            className='campaign-photo'
                                            src={URL.createObjectURL(carouselItems[currentSlide].image)}
                                            alt={`Slide ${currentSlide + 1}`}
                                        />
                                        {carouselItems[currentSlide].buttonText && (
                                            <button className='carousel-preview-button'>
                                                {carouselItems[currentSlide].buttonText}
                                            </button>
                                        )}
                                    </div>
                                    {carouselItems.length > 1 && (
                                        <>
                                            <div className='carousel-preview-nav'>
                                                <button className='carousel-nav-btn' onClick={prevSlide}>&lt;</button>
                                                <span className='carousel-nav-indicator'>
                                                    {currentSlide + 1} / {carouselItems.length}
                                                </span>
                                                <button className='carousel-nav-btn' onClick={nextSlide}>&gt;</button>
                                            </div>
                                            <div className='carousel-preview-dots'>
                                                {carouselItems.map((_, index) => (
                                                    <span
                                                        key={index}
                                                        className={`carousel-dot ${index === currentSlide ? 'active' : ''}`}
                                                        onClick={() => setCurrentSlide(index)}
                                                    />
                                                ))}
                                            </div>
                                        </>
                                    )}
                                </div>
                            ) : (
                                newCampaignData.image && <img className='campaign-photo'
                                                               src={URL.createObjectURL(newCampaignData.image)}
                                                               alt="product"/>
                            )}
                            <p className='campaign-offer-date'>09.09.2019</p>
                        </div>
                        <div className='campaign-offer-message-wrapper'>
                            <div className='campaign-favorites-button'>
                                <img src={favorites} alt="favorites"/>
                            </div>
                            <p className='campaign-offer-message'>{parser(newCampaignData.offerValue)}</p>
                        </div>
                        <hr className='divider'/>
                        <div className='phone-content-company-like-dislike-wrapper'>
                            <div className='phone-content-company-like'>
                                <img src={like} alt="like"/>
                            </div>
                            <div className='phone-content-company-dislike'>
                                <img src={dislike} alt="dislike"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

};

export default CampaignsPreviewPhone;


